<template>
  <div class="team-box">
    <div class="team-header">
      <div class="header-img">
        <img class="img1" :src="userData && userData.avatarName || headerimg" alt="">
        <img class="img2" :src="vipimg" alt="">
      </div>
      <!-- <img :src="headerimg" alt=""> -->
      <div class="team-name">{{userData && (userData.realName? userData.realName : userData.nickName)}}</div>
      <div class="team-header-nav">
        <div>
          <div class="team-number">{{formData && formData.membersCount || 0}}</div> 
          <div class="team-label">团队人数</div>
        </div>
        <div>
          <div class="team-number">{{formData && formData.incomeCount || 0}}</div> 
          <div class="team-label">团队进件数</div>
        </div>
        <div>
          <div class="team-number">{{formData && formData.passCount || 0}}</div> 
          <div class="team-label">成功放款数</div>
        </div>
        <div>
          <div class="team-number">{{formData && formData.teamEarn || 0}}</div> 
          <div class="team-label">佣金金额（元）</div>
        </div>
      </div>
    </div>
    <div class="team-nav">
        <div class="nav-l nav-c">
            <div>团队排行</div>
            <van-button round @click="onCheck" color="#ffc450" plain>查看</van-button>
        </div>
        <div class="nav-r nav-c">
            <div>邀请好友</div>
            <van-button @click="onInvite" round color="#fd9a66" plain>邀请</van-button>
        </div>
    </div>
    <div class="taam-data">
      <div class="team-data-nav">
        <div @click="checkNav(nav,index)" v-for="(nav,index) in navList" :key="index" :class="navLink==nav.type ? 'nav-link nav-link-check' : 'nav-link'">{{nav.name}}</div>
      </div>
      <div class="team-table">
        <!-- 团队人员 -->
        <team-people class="team-table-box" v-if="navLink=='1'"></team-people>
        <!-- 团队进件 -->
        <team-incoming class="team-table-box" v-if="navLink=='2'"></team-incoming>
        <!-- 团队业绩 -->
        <team-performance  v-if="navLink=='3'"></team-performance>
      </div>
    </div>
  </div>
</template>

<script>
import teamPeople from './teamPeople.vue'
import teamIncoming from './teamIncoming.vue'
import teamPerformance from './teamPerformance.vue'
import URL from "@/api/api";
export default {
  components:{
    teamPeople,
    teamIncoming,
    teamPerformance
  },
data(){
  return{
    headerimg: require(`../../assets/publicImg/header.png`),
    vipimg: require('@/assets/publicImg/vip.png'),
    navLink:1,//nav 选择
    navList:[
      {type:'1',name:'团队人员'},
      {type:'2',name:'团队进件'},
      {type:'3',name:'团队业绩'},
    ],
    userData:{},
    formData:{}
  }
},
mounted(){
  this.getUser()
  this.getData()
},
methods:{
  onCheck(){//团队排行
    this.$router.push('/teamRanking')
  },
  onInvite(){//邀请好友
    this.$router.push('/inviteFriends')
  },
  checkNav(v,i){
    this.navLink=v.type
  },
  getUser() {//头像姓名用户信息
    let userId = localStorage.getItem('userid')
    this.$fetchGet(URL.getStaffsCard.url, { userId: userId }).then((res) => {
      this.userData = res.data.data
    })
  },
  getData() {//top 数据
    let that=this
    let userId = localStorage.getItem('userid')
    that.$fetchGet(URL.teamData.url, { userId: userId ,type:'loan'}).then((res) => {
      that.formData = res.data.data
    })
  },
}
}
</script>

<style lang="less" scoped>
.team-box{
  width: 375px;
  // height: 100vh;
  background: #F5F5F5;
}
.team-header{
  width: 375px;
  height: 170px;
  background: url('./img/bg.png') no-repeat 100%;
  background-size: 100% 100% ;
  text-align: center;
  overflow: hidden;
  .team-header-nav{
    width: 335px;
    margin: 15px auto 0 auto;
    display: flex;
    justify-content: space-around;
    .team-number{
      font-size: 14px;
      font-weight: bold;
      color: #333;
    }
    .team-label{
      margin-top: 2.5px;
      font-size: 10.5px;
      font-weight: Medium;
      color:#666666;
    }
  }
  .header-img{
    width: 75px;
    height: 75px;
    margin: 8px auto 0 auto;
    position: relative;
    .img1{
        width: 65px;
        height: 65px;
        border-radius: 50%;
    }
    .img2{
        width: 50px;
        height: 13px;
        position: absolute;
        bottom: 8px;
        left: 13px;
    }
  }
  .team-name{
    font-size: 15px;
    font-weight: bold;
    color: #FFFFFF;
  }
}
.team-nav{
    width: 355px;
    margin: 11px auto 19px auto;
    display: flex;
    justify-content: space-between;
    .nav-c{
    width: 170px;
    height: 40px;
    display: flex;
     align-items: center;
    justify-content: center;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      .van-button{
        width: 55px;
        height: 23px;
        padding: 0;
        margin-left: 18px;
      }
    }
    .nav-l{
        background: url('./img/bg1.png') no-repeat 100%;
         background-size: 100% 100%;
    }
    .nav-r{
        background: url('./img/bg2.png') no-repeat 100%;
         background-size: 100% 100%;
    }
}
.taam-data{
  // width:334px;
  // margin: auto;
  // border: 1px solid;
  .team-data-nav{
    width:355px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    .nav-link{
      width: 108px;
      height: 33px;
      line-height: 33px;
      text-align: center;
      background: url('../../assets/publicImg/li-bg1.png') no-repeat 100%;
      background-size: 100% 100%;
    }
    .nav-link-check{
      font-weight: 500;
      color: #FFFFFF;
      background: url('../../assets/publicImg/li-bg2.png') no-repeat 100%;
      background-size: 100% 100%;
    }
  }
  .team-table{
    margin-top: 15px;
    .team-table-box{
      width:355px;
      margin: auto;
    }
  }
}
</style>